module.exports = __webpack_public_path__ + "img/pizza-slice.9bce5f87.svg";